module.exports = "<table class=\"hovered\">\n  <thead>\n  <tr>\n    <th *ngFor=\"let column of columns\">{{column.title}}</th>\n  </tr>\n  </thead>\n  <tbody>\n\n  <tr *ngFor=\"let row of data\" [@rowState]=\"row.state\">\n\t<ng-template [ngTemplateOutlet]=\"template || emptyTemplate\" [ngOutletContext]=\"{row: row}\">\n\t</ng-template>\n  </tr>\n\n  <ng-template #emptyTemplate let-row=\"row\">\n\t  <td *ngFor=\"let column of columns\">\n\t\t{{row[column.name]}}\n\t  </td>\n  </ng-template>\n\n  </tbody>\n\n</table>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/table/table.component.html
// module id = jLKT
// module chunks = 6